import React, {useState, useEffect} from "react"
import {TextField, Button, Typography, Paper} from "@material-ui/core"
import {useDispatch, useSelector} from "react-redux"
import FileBase from "react-file-base64"
import {useHistory} from "react-router-dom"

import useStyles from "./styles"
import "./form.css"
import {createPost, updatePost} from "../../actions/posts"

const Form = ({currentId, setCurrentId}) => {
  const [postData, setPostData] = useState({title: "", message: "", tags: "", selectedFile: ""})
  const post = useSelector((state) => (currentId ? state.posts.posts.find((message) => message._id === currentId) : null))
  const dispatch = useDispatch()
  const classes = useStyles()
  const user = JSON.parse(localStorage.getItem("profile"))
  const history = useHistory()

  useEffect(() => {
    if (post) setPostData(post)
  }, [post])

  const clear = () => {
    setCurrentId(0)
    setPostData({title: "", message: "", tags: "", selectedFile: "", file: ""})
    var file = document.getElementsByTagName("input")
    file[0].value = ""
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (currentId === 0) {
      dispatch(createPost({...postData, name: user?.result?.name}, history))
    } else {
      dispatch(updatePost(currentId, {...postData, name: user?.result?.name}))
    }
    clear()
  }

  if (!user?.result?.name) {
    return (
      <Paper className={classes.paper}>
        <Typography variant='h6' align='center'>
          You need to Sign In to create or like other's Flux's.
        </Typography>
      </Paper>
    )
  }

  return (
    <Paper className={classes.paper} elevation={6}>
      <form autoComplete='off' noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
        <Typography variant='h6' style={{fontWeight: "700"}} align='left' className='formTitle'>
          {currentId ? `Editing "${post.title}"` : "Creating a Flux"}
        </Typography>
        <TextField required name='title' variant='outlined' label='Title' fullWidth value={postData.title} onChange={(e) => setPostData({...postData, title: e.target.value})} />
        <TextField required name='message' variant='outlined' label='Message' fullWidth multiline rows={4} value={postData.message} onChange={(e) => setPostData({...postData, message: e.target.value})} />
        <TextField name='tags' variant='outlined' label='Tags (comma separated)' fullWidth value={postData.tags} onChange={(e) => setPostData({...postData, tags: e.target.value.split(",")})} />
        <div className='container'>
          <div className='button-wrap'>
            <label className='newButton'>
              Add image
              <FileBase name='file' type='file' multiple={false} onDone={({base64}) => setPostData({...postData, selectedFile: base64})} />
            </label>
          </div>
        </div>
        <Button className={classes.buttonSubmit} variant='contained' size='large' type='submit' fullWidth>
          Submit
        </Button>
        <Button className={classes.clear} variant='contained' onClick={clear} fullWidth>
          Clear
        </Button>
      </form>
    </Paper>
  )
}

export default Form
